<template>
  <span>
    <span v-if="credentials">
      <v-layout>
        <v-row>
          <v-col>
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item-group>
                  <router-link
                    :to="{
                      name: 'creds-details',
                      params: {
                        creds_id:
                          credentials.registered_credentials.credentials_id,
                        account_id: user_details.account_id,
                      },
                    }"
                  >
                    <v-list-item class="mr-2">
                      <v-list-item-icon>
                        <v-icon> mdi-pencil </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Edit Credentials</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </router-link>

                  <v-list-item class="mr-2" @click="deleteCredentials()">
                    <v-list-item-icon>
                      <v-icon> mdi-delete </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Delete Credentials</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <confirm-modal
          ref="confirm"
          title="Delete?"
          confirm-btn-text="OK"
          cancel-btn-text="Cancel"
        >
          <div style="max-width: 350px">
            {{
              `Are you sure you want to delete ${this.credentials.registered_credentials.credentials_id}?`
            }}
          </div>
        </confirm-modal>
      </v-layout>
    </span>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import ConfirmModal from "@/components/shared/ConfirmModal";

export default {
  components: {
    ConfirmModal,
  },
  props: {
    credentials: Object,
  },
  computed: {
    ...mapGetters(["user_details", "account_details"]),
  },
  methods: {
    async deleteCredentials() {
      this.$refs.confirm.show().then((yes) => {
        if (yes) {
          this.$emit("delete_credentials", {
            credentials: this.credentials,
          });
        }
      });
    },
  },
};
</script>
